import { Navigate } from "react-router-dom";
import type { ReactNode } from "react";
import { useSub } from "../../../common/subscription/useSub";
import { urls } from "../../../urls";

export const NeedsRoute = ({ children }: { children: ReactNode }) => {
  const { hasNeedsAccess } = useSub();
  if (!hasNeedsAccess) {
    return <Navigate to={urls.v2.home} replace />;
  }
  return <>{children}</>;
};
